import { render, staticRenderFns } from "./Prescribe.vue?vue&type=template&id=8a83d7bc&scoped=true&"
import script from "./Prescribe.vue?vue&type=script&lang=js&"
export * from "./Prescribe.vue?vue&type=script&lang=js&"
import style0 from "./Prescribe.vue?vue&type=style&index=0&id=8a83d7bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a83d7bc",
  null
  
)

export default component.exports